import React from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronRight, Plus, ShieldCheck } from 'lucide-react';
import { Logo } from './Logo';
import { navItems } from './data';
import { useApp } from './store';
interface SidebarProps {
  open: boolean;
  onClose: () => void;
  onCreatePost: () => void;
}
export function Sidebar({
  open,
  onClose,
  onCreatePost
}: SidebarProps) {
  const {
    config,
    isAdmin
  } = useApp();
  const visibleItems = navItems.filter(item => !config.hiddenNav.includes(item.label));
  return <>
      {/* Mobile overlay */}
      {open && <div className="fixed inset-0 bg-navy-900/50 z-40 lg:hidden" onClick={onClose} aria-hidden="true" data-id="element-797" />}

      <aside className={`fixed lg:sticky top-0 left-0 z-50 h-screen w-64 bg-navy-600 flex flex-col shrink-0 transition-transform duration-300 ${open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`} data-id="element-798">
        {/* Brand */}
        <div className="h-20 flex items-center justify-center border-b border-white/10 px-5 shrink-0" data-id="element-799">
          <NavLink to="/" onClick={onClose} aria-label="Independence Home Loans home" data-id="element-800">
            <Logo className="h-14 max-w-full" data-id="element-801" />
          </NavLink>
        </div>

        {/* Nav */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1" data-id="element-802">
          {visibleItems.map(item => {
          const Icon = item.icon;
          return <NavLink key={item.label} to={item.to} end={item.end} onClick={onClose} className={({
            isActive
          }) => `w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors group ${isActive ? 'bg-gold-500 text-navy-900' : 'text-navy-100 hover:bg-white/10 hover:text-white'}`} data-id="element-803">
                {({
              isActive
            }) => <>
                    <Icon className="w-5 h-5 shrink-0" data-id="element-804" />
                    <span className="flex-1 text-left" data-id="element-805">{item.label}</span>
                    {item.badge ? <span className={`text-xs font-bold px-1.5 py-0.5 rounded-full ${isActive ? 'bg-navy-900 text-gold-400' : 'bg-gold-500 text-navy-900'}`} data-id="element-806">
                        {item.badge}
                      </span> : <ChevronRight className={`w-4 h-4 transition-opacity ${isActive ? 'opacity-60' : 'opacity-0 group-hover:opacity-60'}`} data-id="element-807" />}
                  </>}
              </NavLink>;
        })}

          {isAdmin && <div className="pt-3 mt-3 border-t border-white/10" data-id="element-808">
              <p className="px-3 pb-1 text-[0.65rem] font-bold uppercase tracking-widest text-navy-200" data-id="element-809">
                Admin
              </p>
              <NavLink to="/admin" onClick={onClose} className={({
            isActive
          }) => `w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors group ${isActive ? 'bg-gold-500 text-navy-900' : 'text-navy-100 hover:bg-white/10 hover:text-white'}`} data-id="element-810">
                {({
              isActive
            }) => <>
                    <ShieldCheck className="w-5 h-5 shrink-0" data-id="element-811" />
                    <span className="flex-1 text-left" data-id="element-812">Site Admin</span>
                    <ChevronRight className={`w-4 h-4 transition-opacity ${isActive ? 'opacity-60' : 'opacity-0 group-hover:opacity-60'}`} data-id="element-813" />
                  </>}
              </NavLink>
            </div>}
        </nav>

        {/* Create post CTA */}
        <div className="p-3 border-t border-white/10 shrink-0" data-id="element-814">
          <button onClick={onCreatePost} className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-bold text-navy-900 bg-white rounded-lg hover:bg-gold-100 transition-colors" data-id="element-815">
            <Plus className="w-4 h-4" data-id="element-816" />
            Create Post
          </button>
        </div>
      </aside>
    </>;
}